import type { StepVerticalItem } from '../components/StepVertical/StepVertical';
import type { TrackingScan, TrackingShipment } from '../types/order.types';
import { formatTrackingTime } from './order';

const PREPARING = 'Menyiapkan pengiriman';

/** One step per run of scans (newest first) with the same courier status, titled with that status as the
 *  courier writes it; the newest is the active one. Before the first scan the parcel is being prepared. */
export const toTrackingSteps = (events: TrackingScan[]) => {
  const items: StepVerticalItem[] = [];
  for (const [index, event] of events.entries()) {
    const title = event.courier_status?.trim() || '-';
    const log = {
      description: event.description || '-',
      detail: event.location ?? undefined,
      timestamp: formatTrackingTime(event.occurred_at),
    };
    const last = items[items.length - 1];
    if (last?.title === title) last.logs.push(log);
    else items.push({ id: `scan-${index}`, title, logs: [log] });
  }
  if (items.length === 0) items.push({ id: 'preparing', title: PREPARING, logs: [] });
  return { items, activeIndex: 0, activeTitle: items[0]?.title ?? '' };
};

const TIME_ZONE = 'Asia/Jakarta';
const DAY = 24 * 60 * 60 * 1000;
const dayMonth = new Intl.DateTimeFormat('id-ID', {
  day: 'numeric',
  month: 'short',
  timeZone: TIME_ZONE,
});
const dayMonthYear = new Intl.DateTimeFormat('id-ID', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: TIME_ZONE,
});

/** Estimasi Tiba: when the parcel was handed to the courier plus the quoted estimate ("2-3 day" ->
 *  "24 Okt - 25 Okt 2026"); null before it is handed over or when the estimate has no days. */
export const estimatedArrival = (
  shipment: Pick<TrackingShipment, 'shipped_at' | 'service_etd'>
) => {
  const match = shipment.service_etd?.match(/(\d+)\s*(?:-\s*(\d+))?/);
  if (!shipment.shipped_at || !match) return null;
  const shippedAt = new Date(shipment.shipped_at).getTime();
  const from = new Date(shippedAt + Number(match[1]) * DAY);
  const to = new Date(shippedAt + Number(match[2] ?? match[1]) * DAY);
  const last = dayMonthYear.format(to);
  return from.getTime() === to.getTime() ? last : `${dayMonth.format(from)} - ${last}`;
};
